<template>
    <span v-if="dialog" style="line-height:1"
        :data-component-name="$options.name"
    >
        <q-icon 
            @click.stop="showCard = showCard==false"
            v-bind="$attrs"
            name="info"
            round
        ></q-icon>
        <q-dialog v-model="showCard">

            <ProjectCard
                class="c-project-card__wrap"
                :projectID="projectID"
                :showCard="showCard"
                @close-dialog="showCard=false"
                :myAssignments="myAssignments"
                :projectShiftID="projectShiftID"
            />
        </q-dialog>
    </span>
    <ProjectCard
        v-else
        class="c-project-card__wrap"
        :projectID="projectID"
        :showCard="true"
        :myAssignments="myAssignments"
        :projectShiftID="projectShiftID"
    />
</template>

<script>
    import ProjectCard from '@/components/projects/ProjectCard.vue'

    export default {
        name: 'ProjectCardToggle',
        components: { ProjectCard },
        props: {
        	projectID:{
        		type: [Number, String],
        		default: null,
        	},
            dialog: {
                type: Boolean,
                default: true
            },
            myAssignments: {
                type: Boolean,
                default: false
            },
            projectShiftID: {
                type: [Number, String],
                default: null
            }
        },
        data(){
        	return {
                showCard: false
        	}
        },
        mounted(){
        },
        //computed: {},
        //watch: {},
        methods: {
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/projects/ProjectCard.scss";
    .q-icon {
        margin-top: 0px;
    }
</style>